import { createRoute, lazyRouteComponent } from "@tanstack/react-router";

import { rootRoute } from "../../__root";

export const communitiesQuestionsRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/communities/$communityId/questions",
  component: lazyRouteComponent(
    () =>
      import(
        /* webpackChunkName: "CommunitiesOnboarding" */ "./CommunitiesQuestionsRoute"
      ),
    "CommunitiesQuestionsRoute",
  ),
});
